import { useContext } from "react"
import userContext from "../contexts/userContext"

const useUserContext = () => {
    return useContext(userContext)
}

export default useUserContext